<div class="session-expired" role="alertdialog" aria-labelledby="session-expired-title" aria-describedby="session-expired-text">
  <h1 id="session-expired-title" mat-dialog-title>Sessão expirada</h1>
  <p id="session-expired-text" mat-dialog-content>
    Sua sessão expirou. Entre novamente para continuar.
  </p>
  <div mat-dialog-actions>
    <button type="button" class="session-expired__action" (click)="goToLogin()">
      Voltar ao login
    </button>
  </div>
</div>
